// extracted by mini-css-extract-plugin
export default {"tableHeader":"SupplierClientConnections_tableHeader__kBJIb"};